export default __webpack_public_path__ + "static/media/바다이야기.7a769014.svg";